import { ActionTree } from 'vuex';
import ActionTypes from '@/constants/action-types';
import { RootState } from '@/store/state';
import { cartApiService } from '@/api';
import { CartState } from '@/store/modules/cart/state';
import { CartAddRequestModel, CartEditRequestModel, CartItemRemoveRequestModel } from '@/models/CartRequestModel';
import { CartModel } from '@/models/CartModel';
import { CheckoutRequestModel } from '@/models/CheckoutRequestModel';
import { CheckoutModel } from '@/models/CheckoutModel';

const actions: ActionTree<CartState, RootState> = {

  async [ActionTypes.CartInfo]({ commit }) {
    const cart: CartModel = await cartApiService.cartInfo();
    return commit(ActionTypes.CartInfo, cart);
  },

  async [ActionTypes.AddCart]({ commit }, saveCart: CartAddRequestModel) {
    const cart: CartModel = await cartApiService.addCart(saveCart);
    return commit(ActionTypes.AddCart, cart);
  },

  async [ActionTypes.EditCart]({ commit }, editCart: CartEditRequestModel) {
    const cart: CartModel = await cartApiService.editCart(editCart);
    return commit(ActionTypes.EditCart, cart);
  },

  async [ActionTypes.EmptyCart]({ commit }) {
    await cartApiService.emptyCart();
    return commit(ActionTypes.EmptyCart);
  },

  async [ActionTypes.RemoveCartItem]({ commit }, cartItem: CartItemRemoveRequestModel) {
    const cart: CartModel = await cartApiService.removeCartItem(cartItem);
    return commit(ActionTypes.RemoveCartItem, cart);
  },

  async [ActionTypes.AddCartTip]({ commit }, { type, tip }: { type: 'dollar' | 'percent'; tip: number }) {
    const cart: CartModel = await cartApiService.addTip(type, tip);
    return commit(ActionTypes.AddCartTip, cart);
  },

  async [ActionTypes.RemoveCartTip]({ commit }, type: 'dollar' | 'percent') {
    const cart: CartModel = await cartApiService.removeTip(type);
    return commit(ActionTypes.RemoveCartTip, cart);
  },

  async [ActionTypes.Checkout]({ commit }, payload: CheckoutRequestModel) {
    const checkout: CheckoutModel = await cartApiService.checkout(payload);
    return commit(ActionTypes.Checkout, checkout);
  },

};

export default actions;
